import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedLeadStratalotApiService } from './lead-stratalot-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class LeadStratalotApiService extends GeneratedLeadStratalotApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
